import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImportSettingsRoutingModule } from './import-settings-routing.module';
import { ImportSettingsComponent } from './import-settings.component';
import {AgGridModule} from 'ag-grid-angular';
import { AddNewImportComponent } from './componets/add-new-import/add-new-import.component';
import {Trip2ThemeModule} from '../../trip2-theme/trip2-theme.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {ImportSettingsService} from './import-settings.service';

@NgModule({
  imports: [
    CommonModule,
    ImportSettingsRoutingModule,
    AgGridModule.withComponents([]),
    Trip2ThemeModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [ImportSettingsComponent, AddNewImportComponent],
  providers: [ImportSettingsService]
})
export class ImportSettingsModule { }



// WEBPACK FOOTER //
// ./src/app/pages/import-settings/import-settings.module.ts